import React from 'react'

export const KeDoContext = React.createContext();